<template>
  <div
    id="app"
    class="app"
  >
    <main
      :key="$route.name"
      class="app-content"
    >
      <router-view class="app-route" />
    </main>
  </div>
</template>

<script>
  export default {
    name: 'App',
  };
</script>

<style lang="scss">
  @import '@cordel/assets/stylesheets/tokens.scss';
  @import '@cordel/assets/stylesheets/subtokens.scss';

  @import 'assets/stylesheets/base.scss';

  .app {
    position: relative;
  }

  .app-route {
    position: relative;
  }

  .app-content {
  }
</style>
